import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/modules/shared/lib/axios'

export interface CompanyNipMismatch {
  companyId: string
  companyName: string
  profileNip: string
  settingsNip: string
}

export function useQueryCompanyNipMismatches() {
  return useQuery<CompanyNipMismatch[]>({
    queryKey: ['admin.companyNip.mismatches'],
    queryFn: async () => {
      const { data } = await axiosInstance.get(
        '/config-api/admin/company-nip/mismatches',
      )
      return data
    },
    staleTime: 10 * 60_000,
  })
}
